import PropTypes from "prop-types"
import { Button, IconButton, Typography } from "@mui/material"
import { CloudDownload } from "@mui/icons-material"
import { isEmpty } from "lodash"
import ConfirmIntegrationDialog from "../confirm-integration-dialog"
import ApplicationLogo from "../application-logo"
import { Link, useNavigate } from "react-router-dom"
import { STATUSES } from "modules/platform/constants"

import "./style.scss"

const { NONE, REQUESTED, ACTIVE } = STATUSES

function renderCTA(status, account, legalAccountName, onClick) {
  if (status === NONE) {
    return <Button disabled={isEmpty(legalAccountName)} color="primary" className="confirm" onClick={onClick}>Start integration</Button>
  }

  if (status === ACTIVE) {
    return <Button color="primary" className="confirm"><Link to={`/${account}/applications/eze`}>Get started</Link></Button>
  }

  return <Button color="primary" disabled variant="outlined" className="confirm">Request pending</Button>
}

export default function EzeIntegration({
  account,
  legalAccountName,
  status,
  terms,
  termsVersion,
  isSuperuser,
  acceptPermission,
  openDialog,
  closeDialog,
}) {
  const navigate = useNavigate()

  function enableEzeIntegration(legalText) {
    acceptPermission(account, window.location.href, legalText)
    closeDialog()
    navigate(`/${account}/home/resources`)
  }

  function confirm() {
    if (isSuperuser) {
      enableEzeIntegration()
      return
    }

    openDialog({
      title: <div id="eze-integration-dialog-header">
        <Typography variant="h6">Eze Eclipse Permissions</Typography>
        <IconButton
          className="download"
          color="secondary"
          variant="contained"
          component="a"
          target="_blank"
          href={`https://assets.ompnt.com/terms/Eze_Integration-Permissions.v${termsVersion}.pdf`}
          download
          size="large"
        >
          <CloudDownload />
        </IconButton>
      </div>,
      content: <ConfirmIntegrationDialog closeDialog={closeDialog} confirm={enableEzeIntegration} termsText={terms} />,
    })
  }

  return <div id="components_eze-integration" className="app-card integration">
    <ApplicationLogo url="eze.png" name="SS&C Eze" />
    <div className="header">
      <div className="name-wrapper">
        <div className="name">SS&C Eze</div>
      </div>
    </div>
    <div className="body">
      <p className="description">This integration allows mutual customers to import their portfolios and forecasts from SS&C Eze Eclipse into Omega Point&apos;s ecosystem.</p>
      {renderCTA(status, account, legalAccountName, confirm)}
    </div>
  </div>
}

EzeIntegration.propTypes = {
  account: PropTypes.string.isRequired,
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
  status: PropTypes.oneOf([NONE, REQUESTED, ACTIVE]),
  terms: PropTypes.string,
  termsVersion: PropTypes.number,
  legalAccountName: PropTypes.string,
  isSuperuser: PropTypes.bool.isRequired,
  acceptPermission: PropTypes.func.isRequired,
}
